import {
  BaseIntegrationConfig,
  BaseIntegrationConfigRequest,
  createIntegrationAPI,
} from "restAPI/GenericIntegrationAPI";

export const GOOGLE_WORKSPACE_INTEGRATION_TYPE = "GOOGLE_WORKSPACE";
export const GOOGLE_WORKSPACE_AUTH_TYPE = "IAM_ROLE";
export const GOOGLE_WORKSPACE_DEFAULT_STATUS = "ACTIVE";

export type GwsProduct = string;

export interface GwsProductMetadata {
  id: string;
  label: string;
  description: string;
  enabled: boolean;
  status: string;
  requiredScopes: string[];
}

export interface GoogleWorkspaceConfig extends BaseIntegrationConfig {
  authType: string;
  authConfig: {
    impersonationEmail: string;
  };
  configProperties: {
    aiemGwsProducts: GwsProduct[];
  };
}

export interface GoogleWorkspaceConfigRequest
  extends BaseIntegrationConfigRequest {
  status: string;
  authType: string;
  uuid?: string;
  authConfig: {
    impersonationEmail: string;
  };
  configProperties: {
    aiemGwsProducts: GwsProduct[];
  };
}

export const GoogleWorkspaceAPI = createIntegrationAPI<
  GoogleWorkspaceConfig,
  GoogleWorkspaceConfigRequest
>(GOOGLE_WORKSPACE_INTEGRATION_TYPE);

export const emailValidator = {
  type: "email" as const,
  message: "Please enter a valid email address",
};
